<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="cont_1"></a><a id="page_vii"></a><strong>Contents</strong></h2>
<p class="toc"><a href="#/xhtml/intro#intro_1"><strong>Introduction</strong></a></p>
<p class="toc-chap"><a href="#/xhtml/ch01#ch01_1"><span class="smallcaps">CHAPTER 1</span>    <strong>Delivering a Culture</strong></a></p>
<p class="toc-chap"><span href="#/xhtml/ch02#ch02_1" title="Link target outside of Sample"><span class="smallcaps">CHAPTER 2</span>    <strong>Building a Successful Team</strong></span></p>
<p class="toc-chap"><span href="#/xhtml/ch03#ch03_1" title="Link target outside of Sample"><span class="smallcaps">CHAPTER 3</span>    <strong>Divine Intervention</strong></span></p>
<p class="toc-chap"><span href="#/xhtml/ch04#ch04_1" title="Link target outside of Sample"><span class="smallcaps">CHAPTER 4</span>    <strong>Developing Your Team’s Unique Talents</strong></span></p>
<p class="toc-chap"><span href="#/xhtml/ch05#ch05_1" title="Link target outside of Sample"><span class="smallcaps">CHAPTER 5</span>    <strong>Targeting the Most Critical Information</strong></span></p>
<p class="toc-chap"><span href="#/xhtml/ch06#ch06_1" title="Link target outside of Sample"><span class="smallcaps">CHAPTER 6</span>    <strong>Cultivating the X Factor</strong></span></p>
<p class="toc-chap"><span href="#/xhtml/ch07#ch07_1" title="Link target outside of Sample"><span class="smallcaps">CHAPTER 7</span>    <strong>Maintaining an Ethical Environment</strong></span></p>
<p class="toc-chap"><span href="#/xhtml/ch08#ch08_1" title="Link target outside of Sample"><span class="smallcaps">CHAPTER 8</span>    <strong>Fostering Positive Interactions</strong></span></p>
<p class="toc-chap"><span href="#/xhtml/ch09#ch09_1" title="Link target outside of Sample"><span class="smallcaps">CHAPTER 9</span>    <strong>Moving Forward</strong></span></p>
<p class="toc-chap"><span href="#/xhtml/ch10#ch10_1" title="Link target outside of Sample"><span class="smallcaps">CHAPTER 10</span>  <strong>Prepare for Places Unexpected</strong></span></p>
<p class="toc-chap"><span href="#/xhtml/ch11#ch11_1" title="Link target outside of Sample"><span class="smallcaps">CHAPTER 11</span>  <strong>Signed, Sealed, and Delivered</strong></span></p>
<p class="toc"><span href="#/xhtml/ch019#ch019_1" title="Link target outside of Sample"><strong>A Study Guide for Leaders and Their Teams</strong></span></p>
<p class="toc-bm"><span href="#/xhtml/epigraph#epigraph_1" title="Link target outside of Sample"><strong>Endnotes</strong></span></p>
<p class="toc-bm"><span href="#/xhtml/epilogue#epilogue_1" title="Link target outside of Sample"><strong>The “We” (It’s Not Just Me!)</strong></span></p>
<p class="toc-bm"><span href="#/xhtml/ack#ack_1" title="Link target outside of Sample"><strong>Acknowledgments</strong></span></p>
<p class="toc-bm"><span href="#/xhtml/index#index_1" title="Link target outside of Sample"><strong>Index</strong></span></p>
<p class="toc-bm"><span href="#/xhtml/author#author_1" title="Link target outside of Sample"><strong>About the Author</strong></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cont.vue?ed9633b4